import * as service from './service'
export default {
  namespace: 'equipmentMallCouponCollectionCenter',
  state: {
    demoData: {}
  },
  effects: {
    * queryCouponList ({ payload }, { call, put }) {
      const res = yield call(service.queryCouponList, payload)
      return res.data
    },
    * acquireCoupon ({ payload }, { call, put }) {
      const res = yield call(service.acquireCoupon, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
